import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { useHistory } from 'react-router';
import themeColors from '../../assets/styles/themeColors';
import { HeadingSubtitle } from '../../components/Heading';
import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';
import SelectAccountDescription from '../../components/SelectAccountDescription';
import { useMenu } from '../../hooks/useMenu';
import { selectSettings } from '../../store/selectors/settingsSelectors';

const SecureAccountEinQuestion = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { activeMenu, activeItem } = useMenu();
  const settings = useSelector(selectSettings);
  const { BrokerName } = settings;

  const options = () => [
    {
      title: t('secureAccountTrustEinQuestion.no'),
      onClick: () => history.push(activeItem?.nextPath),
    },
    {
      title: t('secureAccountTrustEinQuestion.yes'),
      onClick: () => history.push(activeItem?.nextPath),
      showDivider: false,
    },
  ];

  return (
    <OnBoardingContainer
      activeMenu={activeMenu}
      activeItem={activeItem}
      previousPath={activeItem?.previousPath}
    >
      <Helmet>
        <title>
          {t('titleTagEin', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <HeadingSubtitle mb={32} color={themeColors.colorTextSecondary}>
        {t('secureAccountTrustEinQuestion.title')}
      </HeadingSubtitle>
      <SelectAccountDescription
        options={options()}
        onlyTitle
        titleWeight={400}
      />
    </OnBoardingContainer>
  );
};

export default SecureAccountEinQuestion;
